import comp from "./QuestionLibraryFeed";
export default comp;
